

import shell2 from "../assets/gido (14).jpg"
import shell3 from "../assets/gido (33).jpg"
import ship from "../assets/shipw.webp"
import ship2 from "../assets/shipw2.webp"
import ship3 from "../assets/shipw3.webp"
import ship4 from "../assets/shipw4.webp"
import Aos from 'aos';
import 'aos/dist/aos.css'
import sanga3 from "../assets/gido (1).jpg"
import camb from "../assets/camb.jpg"
import sanga from "../assets/sanga.webp"
import umbria from "../assets/omria.jpg"
import irg from "../assets/irg.webp"
import dive from "../assets/camb (1).jpg"
import shore from "../assets/shore.png"

import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import Slider from "react-slick";
function Home() {

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const { t } = useTranslation();

  useEffect(() => {
    Aos.init({ duration: 2000 });
  });

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const images = [camb, sanga, umbria, irg, dive, shore,]

  return (
    <div className="h-full">
      <style>
        {`
          @keyframes floatShip {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
        `}
      </style>

      <div className="w-full h-full relative" >
        <img src={shell3} className="w-full h-full object-cover" />

        <div className='absolute inset-0 bg-black/40 flex items-center justify-center flex-row'>

          <div className=" flex items-center  flex-col rtl h-full p-4 m-6 justify-center">
            <h1 data-aos="fade-right" className="text-white  text-4xl md:text-7xl font-bold">{t("main")}</h1>
            <h3 data-aos="fade-left" className="text-white  text-xl md:text-xl font-bold p-4">{t("main2")}</h3>
          </div>
        </div></div>

      {/* ////////////////////////////////////////////// */}


      <div className="h-auto my-4 w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">
        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">Blue Shark </h2>

          <p className="text-gray-700 font-bold">
            {t("info")}
          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] '>
          <img src={sanga3} data-aos="fade-right"
            className="md:w-[80%] md:h-[40%]  h-full w-full max-w-[500px] object-cover rounded border-blue-300 flex-shrink-0" />
          <div className="absolute inset-0 flex  flex-col justify-center">
          </div>
        </div>

      </div>


      {/* //////////////////////////////// */}
      <center data-aos="fade-up"><h1 className="my-4 text-4xl font-bold mb-2 text-gray-700">{t("marine")} </h1>
        <p className="text-gray-500">{t("marine2")}</p>
      </center>
      <div className=" text-center relative w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 items-center justify-center my-6" >
        <div className=" aspect-[4/3]">
          <img src={ship} className="w-full h-full  " data-aos="fade-up" />
          <h1 className=" text-xl font-bold mb-2 text-gray-700 " data-aos="fade-up" >{t("supply")} </h1>
          <p data-aos="fade-up"  >{t("supply2")}
          </p>
        </div>
        <div className=" aspect-[4/3]">
          <img src={ship2} className="w-full h-full" data-aos="fade-up" />
          <h1 className=" text-xl font-bold mb-2 text-gray-700" data-aos="fade-up" >{t("offshore")} </h1>
          <p data-aos="fade-up" >{t("offsore2")}
          </p>
        </div>
        <div className=" aspect-[4/3]">
          <img src={ship3} className="w-full h-full" data-aos="fade-up" />
          <h1 className=" text-xl font-bold mb-2 text-gray-700" data-aos="fade-up" >{t("civil")}</h1>
          <p data-aos="fade-up" >{t("civil2")}
          </p>
        </div>
        <div className="aspect-[4/3] ">
          <img src={ship4} className="w-full h-full" data-aos="fade-up" />
          <h1 className="text-xl font-bold mb-2 text-gray-700" data-aos="fade-up" >{t("husbandry")}</h1>
          <p data-aos="fade-up" >{t("husbandry2")}
          </p>
        </div>
      </div>

      {/* //////////////////////////////// */}


      <div className="h-auto  w-full flex flex-col md:flex-row-reverse items-center gap-4 p-4 bg-white ">

        <div data-aos="fade-left" dir={i18n.language === "ar" ? "rtl" : "ltr"} className="text-left ml-4  flex flex-col justify-center flex-1 h-full overflow-auto px-6">
          <h2 className="text-4xl font-bold mb-2 text-gray-700">{t("time")}</h2>
          <p className="text-gray-700 ">
            {t("info2")}
          </p>

        </div>
        <div className='relative md:w-[50%] md:h-[40%] '>
          <img src={shell2} data-aos="fade-right" className="md:w-[80%] md:h-[40%]  h-full w-[500px] object-cover rounded
      border-blue-300 flex-shrink-0"/>
          <div className="absolute inset-0 flex  flex-col justify-center ">

          </div>
        </div>

      </div>


      {/* //////////////////////////////// */}


      <div className='w-full  my-10 rounded-2xl shadow-xl p-4'>
        <center>
          <h1 data-aos="fade-up" className='font-serif text-gray-600 text-4xl md:text-4xl font-bold my-4'> Galary</h1></center>
        <div data-aos="fade-up" className=' max-w-6xl mx-auto  md:columns-3 gap-8 sm:columns-2 columns-1 '>

          {images.map((image, index) => (
            <img src={image} className=' mb-4 rounded-lg shadow-xl transition-transform duration-500 ease-in-out
 hover:scale-110 '/>
          ))}
        </div></div>
    </div>
  )
}

export default Home;